<template>
    <div>
        <div style="display:flex;justify-content: center;margin-top: 50.3px;">
        <img src="../../assets/img/entryPic.png"/>
    </div>
    <div style="text-align:center;">
        <p style="padding-top:20.7px;font-size:20px;color:#000000">Zhulia Seller Onboarding</p>
        <p style="color:#777777">As a new business, there's a few things we need from you to get you</p>
        <p>onboard and managing your business operations</p>
    </div>
    <div style="display:flex;justify-content: space-evenly;padding-top:30px">
        <div style="background:#e5efe7;width:185px;height:215px;">
            <div style="display:flex;justify-content: center; padding-top:20px;color:#98c14b">
                <a-icon type="clock-circle" />
            </div>
            <p style="text-align:center;color:#000000;font-size:16px;padding-top:24px">Takes 10 to 15 </p>
            <p style="text-align:center;color:#000000;font-size:16px"> minutes</p>
            <p style="text-align:center;color:#000000;font-size:12px;padding-top:15px">..or one coffee break</p>
            
        </div>
        <div style="background:#e5efe7;width:185px;height:215px;">
            <div style="display:flex;justify-content: center; padding-top:20px;color:#98c14b">
                <a-icon type="calendar" />
            </div>
            <p style="text-align:center;color:#000000;font-size:16px;padding-top:24px">Good to have </p>
            <p style="text-align:center;color:#000000;font-size:12px;padding:15px">Business Information Document and your personal details</p>
            
        </div>
        <div style="background:#e5efe7;width:185px;height:215px;">
            <div style="display:flex;justify-content: center; padding-top:20px;color:#98c14b">
                <a-icon type="check-circle" />
            </div>
            <p style="text-align:center;color:#000000;font-size:16px;padding-top:24px">Your progress</p>
            <p style="text-align:center;color:#000000;font-size:16px">will be saved</p>
            <p style="text-align:center;color:#000000;font-size:12px;padding:15px">Exit and finish later if you need to</p>
            
        </div>
    </div>
   
    <div style="display: flex;justify-content: center;align-items: center;padding-top:90px;margin-bottom:50px">
        <a-button @click="handleNext" style="background: #418a49;height:45px;color:#fff;width:256px;">
            Start
        </a-button>
    </div>
    
</div>
</template>

<script>
import { mapActions } from 'vuex';
    export default {
        name:"Welcome",
        methods:{
            ...mapActions(['setProgressBar']),
            handleNext(){
                this.setProgressBar(true);
                this.$router.push(`/steps`).catch(()=>{});
            }
        }
    }
</script>

<style lang="scss" scoped>

</style>